var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "version-update-box" }, [
    _c("section", { staticClass: "intro flexBox" }, [
      _c("div", { staticClass: "box flexBox" }, [
        _c("img", {
          style: _vm.styleObj,
          attrs: { src: "/static/images/update_01.png" }
        }),
        _vm._v(" "),
        _c("img", {
          style: _vm.styleObj,
          attrs: { src: "/static/images/update_02.png" }
        }),
        _vm._v(" "),
        _c("img", {
          style: _vm.styleObj,
          attrs: { src: "/static/images/update_03.png" }
        })
      ]),
      _vm._v(" "),
      _c("span", {
        staticClass: "switch-btn",
        domProps: {
          textContent: _vm._s(_vm.showIndex !== 2 ? "下一步" : "立即体验")
        },
        on: { click: _vm.switchImg }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-3425893e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-3425893e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/versionUpdate.vue
// module id = null
// module chunks = 